module.exports = __webpack_public_path__ + "static/media/bookingsTable.dc16fbe1.jpg";